import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tab, TabList } from "@fluentui/react-tabs";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { BORDER, SELECTED_TAB_KEY, USERTYPES } from "../../constants/Constants";
import TroubleShootingTab from "../IssuesAndTroubleshooting/TroubleShootingTab";
import userContext from "../../context/users/UserContext";
import { t } from "i18next";
import {
  checkAccessForAugmentoTab,
  checkAccessForClientTab,
  checkAccessForCustomTab,
  getTabDetailsBasedOnRole,
} from "./helper/helper";
import AugmentoReportTemplate from "./AugmentoReportTemplate";
import ClientReportTemplate from "./ClientReportTemplate";
import CustomReportTemplate from "./CustomReportTemplate";
import "./ReportTemplate.css";
import { Icon } from "@fluentui/react";
import { getClientsList, getFirmsList, getModalityList, getRadiologistList } from "../../service/MasterService";
import FirmReportTemplate from "./FirmReportTemplate";
import themeContext from "../../context/theme/ThemeContext";

const ReportTemplateListv2 = () => {
  const { getThemeColor } = useContext(themeContext);
  const { tabId } = useParams();
  const [selectedValue, setSelectedValue] = useState(
    SELECTED_TAB_KEY.REPORTTEMPLATE + tabId
  );

  const navigate = useNavigate();
  const { roles, loadByUsername, authenticated, firmId, checkForUserAccess } = useContext(userContext);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const [radiologistList, setRadiologistList] = useState([]);
  const [firmList, setFirmList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const onTabSelect = (event, data) => {
    let currentTab = data.value;
    console.log("currentTab->", currentTab);
    document.getElementById(currentTab).style.border = getThemeColor("border");
    document.getElementById(currentTab).style.borderBottom = "unset";
    document.getElementById(currentTab).style.borderRadius =
      "10px 10px 0px 0px";
    for (
      let i = 1;
      i <= getTabDetailsBasedOnRole(selectedValue, roles[0]).length;
      i++
    ) {
      if (currentTab.charAt(currentTab.length - 1) != i) {
        document.getElementById(
          SELECTED_TAB_KEY.REPORTTEMPLATE + `${i}`
        ).style.border = "";
        document.getElementById(
          SELECTED_TAB_KEY.REPORTTEMPLATE + `${i}`
        ).style.borderRadius = "";
        document.getElementById(
          SELECTED_TAB_KEY.REPORTTEMPLATE + `${i}`
        ).style.borderBottom = "";
      }
    }
    setSelectedValue(data.value);
    navigate("/report/list/template/" + data.value.slice(-1));
  };

  useEffect(() => {
    if (
      document.getElementById(SELECTED_TAB_KEY.REPORTTEMPLATE + tabId) != null
    ) {
      document.getElementById(
        SELECTED_TAB_KEY.REPORTTEMPLATE + tabId
      ).style.border = getThemeColor("border");
      document.getElementById(
        SELECTED_TAB_KEY.REPORTTEMPLATE + tabId
      ).style.borderBottom = "unset";
      document.getElementById(
        SELECTED_TAB_KEY.REPORTTEMPLATE + tabId
      ).style.borderRadius = "10px 10px 0px 0px";
    }
  }, [authenticated]);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, [authenticated]);

  useEffect(() => {
    checkForUserAccess();
  }, [roles[0]]);

  useEffect(() => {
    let tempBreadCrumbItems =
      roles[0] === USERTYPES.ADMIN
        ? [
            {
              text: t("report-templates.list"),
              key: "report_templates",
            },
          ]
        : [
            {
              text: t("report-templates.list"),
              key: "report_templates",
            },
          ];
    setBreadCrumbItems(tempBreadCrumbItems);
  }, [roles]);

  const getModalityListFunc = async() => {
    console.log("--- Modality List ---");
    try{
      const res = await getModalityList();
      if(res.status == 200){
        console.log(res.data.data.modalityList);
        setModalityList(res?.data?.data?.modalityList);
      }
    }catch(e){
      console.log("--- Error getting modality list ---",e);
    }
  }

  const getClientListFunc = async() => {
    
    if(firmId != null && firmId != undefined && (roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR)){
      try{
        console.log("--- Call started ---");
        const res = await getFirmsList();
        
        if(res.status === 200){
          console.log("--- Client List ---",res);
          const filteredClientList = res?.data?.data;
          console.log(filteredClientList);
            setClientList(filteredClientList);
        }
      }catch(e){
        console.log("--- Error getting client list ---",e);
      }
    }
  }

  const getRadiologistListFunc = async() => {
    console.log("--- Radiologist List ---");
    try{
      const res = await getRadiologistList();
      if(res.status == 200){
        setRadiologistList(res?.data?.data);
      }
    }catch(e){
      console.log("--- Error getting modality list ---",e);
    }
  }

  const getFirmListFunc = async() => {
    console.log("--- Radiologist List ---");
    try{
      const res = await getFirmsList();
      if(res.status == 200){
        setFirmList(res?.data?.data);
      }
    }catch(e){
      console.log("--- Error getting modality list ---",e);
    }
  }

  useEffect(()=>{
    getModalityListFunc();
  },[]);

  useEffect(()=>{
    getClientListFunc();
    if(roles[0] === USERTYPES.ADMIN){
      getRadiologistListFunc();
      getFirmListFunc();
    }
  },[firmId])

  const checkForClientExist = () => {
    return (
      ((roles[0] === USERTYPES.FIRMADMIN && clientList?.length > 0) ||
        roles[0] != USERTYPES.FIRMADMIN) &&
      ((roles[0] === USERTYPES.SUPERVISOR && clientList?.length > 0) ||
        roles[0] != USERTYPES.SUPERVISOR) &&
      roles[0] !== USERTYPES.ADMIN
    );
  }

  return (
    <>
      {authenticated && (
        <div className="main-container-body">
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div
            style={{
              padding: "0px 3px",
              boxSizing: "border-box",
              marginTop: "10px",
              height:"calc(100% - 101px)"
            }}
          >
            <ReportTemplateTabSection
              onTabSelect={onTabSelect}
              selectedValue={selectedValue}
              tabDetails={getTabDetailsBasedOnRole}
              roles={roles}
            />
            <div
              style={{
                borderBottom: getThemeColor("border"),
                width: "100%",
                boxSizing: "border-box",
              }}
            ></div>
            {checkAccessForCustomTab(selectedValue, roles[0]) && modalityList?.length > 0 && ((roles[0] === USERTYPES.ADMIN && radiologistList?.length > 0) || roles[0] != USERTYPES.ADMIN) && (
                <CustomReportTemplate modalityList={modalityList} radiologistList={radiologistList} tabId={tabId} />
            )}

            {checkAccessForAugmentoTab(selectedValue, roles[0]) && modalityList?.length > 0 && (
                <AugmentoReportTemplate modalityList={modalityList} tabId={tabId} />
            )}

            {checkAccessForClientTab(selectedValue, roles[0]) && (modalityList?.length > 0) && checkForClientExist() && (
                <ClientReportTemplate modalityList={modalityList} clientList={clientList} tabId={tabId} />
            )}

            {checkAccessForClientTab(selectedValue, roles[0]) && (modalityList?.length > 0) && (roles[0] === USERTYPES.ADMIN && firmList?.length > 0) && (
                <FirmReportTemplate modalityList={modalityList} firmList={firmList} tabId={tabId} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ReportTemplateListv2;

const ReportTemplateTabSection = ({
  onTabSelect,
  selectedValue,
  tabDetails,
  roles,
}) => {
  const getTabActiveStatus = (tabId) => {
    // console.log(tabId);
    // console.log(tabId + "   " + selectedValue);
    if (selectedValue === tabId) {
      // console.log(tabId + "   " + selectedValue);
      return true;
    }
    return false;
  };

  return (
    <TabList
      style={{ marginLeft: "10px" }}
      className="tab-list-container-cmp tabList"
      defaultSelectedValue="nav_1"
      selectedValue={selectedValue}
      onTabSelect={onTabSelect}
    >
      {tabDetails(selectedValue, roles[0]).map((tabElement, index) => {
        return (
          <Tab
            key={index}
            className="top-tab-cmp"
            id={SELECTED_TAB_KEY.REPORTTEMPLATE + (index + 1).toString()}
            value={SELECTED_TAB_KEY.REPORTTEMPLATE + (index + 1).toString()}
          >
            {
              // <TroubleShootingTab
              //   title={tabElement.title}
              //   icon={tabElement.icon}
              //   contentClass={tabElement.contentClass}
              //   active={getTabActiveStatus(tabElement.id)}
              // />
              <div className={tabElement.contentClass} style={{padding: "0px 15px" ,display: "flex", justifyContent: "center"}}>
                <Icon className="icon">{tabElement.icon}</Icon>
                <h4
                  className={`textContent-study-list ${
                    getTabActiveStatus(tabElement.id) ? "highlight-tab" : ""
                  }`}
                >
                  {tabElement.title}
                </h4>
                {getTabActiveStatus(tabElement.id) && (
                  <div className="hide-border-bottom-border-tabs"></div>
                )}
              </div>
            }
          </Tab>
        );
      })}
    </TabList>
  );
};
